import React from 'react';
import { Box, ModuleBase, Text, Stack, Link, ResponsiveImage } from '@/components';
import classNames from 'classnames';
import { animControllerInView, fadeIn } from '@/animations';
import { SideBySideModuleModel } from './SideBySideModule';

const ICPStartshaping = (data: SideBySideModuleModel) => {
  const { alignment, title, cards, image, link1, link2 } = data.props;

  return (
    <ModuleBase
      noPadding
      data={{ ...data, props: { ...data.props, backgroundColour: '#1b3e4e' } }}
      className={classNames(
        'ICPStartshaping relative flex flex-col items-center lg:flex-row',
        alignment === 'Right' ? 'justify-end' : 'justify-start',
      )}
    >
      {image && (
        <Stack
          animation={animControllerInView({ amount: 0.3 })}
          className="relative aspect-square w-full overflow-hidden sm:aspect-[unset] sm:h-[500px] lg:min-h-[622px] lg:w-1/2 xl:min-h-[908px]"
        >
          {image && image.desktopImage && (
            <ResponsiveImage
              animation={fadeIn}
              image={image.desktopImage}
              widths={{ xs: 425, sm: 768, md: 758, lg: 512, xl: 720, xxl: 950 }}
              heights={{ xs: 425, sm: 500, md: 500, lg: 622, xl: 850, xxl: 850 }}
            />
          )}
          <div className="absolute top-2/4 left-2/4 block aspect-square h-full -translate-x-2/4 -translate-y-2/4 rounded-full border border-white lg:h-auto lg:w-full" />
        </Stack>
      )}

      <div className="left-0 flex w-full items-center py-10 lg:absolute lg:h-full lg:py-0">
        <div
          className={classNames(
            'container flex lg:h-full lg:py-18',
            alignment === 'Right' ? 'lg:justify-start' : 'lg:justify-end',
          )}
        >
          <Stack
            className={classNames(
              'flex w-full flex-col lg:w-1/2 lg:justify-between',
              alignment === 'Right' ? 'lg:pr-9' : 'lg:pl-9',
            )}
          >
            {title && (
              <Text
                className="text-style-h2 text-[#61a5e1] lg:pr-10 lg:text-left xl:w-11/12 xl:leading-[90%]"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            <div className="w-full">
              {cards && (
                <div className="mt-10 flex-col gap-5">
                  {cards.map((card, index) => (
                    <Box
                      key={index}
                      className="border-from-bg mt-4 flex flex-col gap-1 border-b border-solid pb-4 first:pt-4 last:border-b-0"
                    >
                      <p className="text-style-h5">{card.title}</p>
                    </Box>
                  ))}
                </div>
              )}
              <div className="flex flex-col lg:flex-row lg:items-start lg:gap-3">
                {link1 && (
                  <Link
                    animate
                    className="btn primary btn-from-bg v2 mt-0 !text-[#1b3e4e] hover:!text-white lg:mt-8"
                    link={link1}
                  />
                )}
                {link2 && <Link animate className="btn secondary btn-from-bg v2 mt-5 lg:mt-8" link={link2} />}
              </div>
            </div>
          </Stack>
        </div>
      </div>
    </ModuleBase>
  );
};

export default ICPStartshaping;
